import React from 'react'
import Receipting from './Receipting'
import useIsBlocked from 'src/hooks/useIsBlocked'
import PermissionBlockScreen from 'src/components/shared/PermissionBlockScreen'

const ReceiptingScreen = () => {
  const blocked = useIsBlocked('receipting')

  if (blocked) {
    return <PermissionBlockScreen />
  }

  return <Receipting />
}

export default ReceiptingScreen
